import { PerformanceLabPlan, PerfLabOffer } from './types';

export const MONSOON_OFFER_ENDS = '2026-08-18T23:59:59+05:30';

// Kept out of ./plans so importing it doesn't pull the 145KB plan catalogue.
export const getActivePlanOffer = (
  plan: PerformanceLabPlan,
): PerfLabOffer | null => {
  if (!plan.offer) return null;
  if (!plan.offer.expiresAt) return plan.offer;
  return Date.now() < new Date(plan.offer.expiresAt).getTime()
    ? plan.offer
    : null;
};
